import styled from "styled-components";
import EditIcon from "@material-ui/icons/Edit";
import RefreshIcon from "@material-ui/icons/Refresh";
import RemoveCircleOutlineRoundedIcon from "@material-ui/icons/RemoveCircleOutlineRounded";
import DoneIcon from "@material-ui/icons/Done";
import CloseRoundedIcon from "@material-ui/icons/CloseRounded";
import AddIcon from "@material-ui/icons/Add";
import FilterListIcon from "@material-ui/icons/FilterList";

export const Container = styled.div`
  list-style-type: none;
  padding: 0.5rem;
  height: 100%;
  background-color: #212326;
  border-radius: 10px;
  overflow-y: auto;
  overflow-x: visible;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  user-select: none;
`;

export const Header = styled.header`
  display: flex;
  justify-content: space-between;
  width: 100%;
  border-radius: 8px;
  padding: 10px;
  align-items: center;
  height: 4rem;
  margin-bottom: 0.5rem;
  background-color: #42464c;
  box-sizing: border-box;
`;

export const Title = styled.span`
  background-color: none; //  #585e66;
  color: #fff; //#40e5a0;
  padding: 5px;
  border-radius: 5px;

  font-family: "Sora";
  font-style: normal;
  font-weight: 700;
  font-size: 1.5rem;
  line-height: 2rem;

  color: #eff1f5;
`;
export const ScrollContainer = styled.div`
  height: 100%;
  width: 100%;
  display: flex;
  overflow-y: hidden;
  background-color: #585e66; //#7e858f;
  border-radius: 10px;
`;

export const StyledList = styled.ul`
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin: 0px;

  height: 100%;
  list-style-type: none;
  width: calc(100% - 5px);

  overflow-y: auto;
  overflow-x: hidden;
  box-sizing: border-box;

  ::-webkit-scrollbar {
    width: 4px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: gainsboro;
    border-radius: 6px;
    margin-top: 10px;
    margin-bottom: 10px;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background-color: #212326;
    border-radius: 6px;
    background-clip: content-box;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #000;
  }
`;

export const ListItemContainer = styled.li`
  &:not(:last-child) {
    margin-bottom: 10px;
  }
`;

export const RemoveButton = styled.button``;

export const IconSpace = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const CustomEditIcon = styled(EditIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #c6c7c8; //#40e5a0;
  margin-right: 5px;

  cursor: pointer;
`;

export const CustomRefreshIcon = styled(RefreshIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #c6c7c8; //#40e5a0;
  margin-left: 5px;
  cursor: pointer;
`;

export const CustomRemoveIcon = styled(RemoveCircleOutlineRoundedIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #eb5757;
  cursor: pointer;
`;
export const CustomConfirmIcon = styled(DoneIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #40e5a0;
  margin-right: 5px;

  cursor: pointer;
`;
export const CustomCancelIcon = styled(CloseRoundedIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #eb5757;
  margin-left: 5px;
  cursor: pointer;
  margin-left: 5px;
`;

export const CustomAddIcon = styled(AddIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #40e5a0;
  margin-left: 5px;
  cursor: pointer;
  margin-left: 5px;
`;
export const CustomFilterIcon = styled(FilterListIcon)`
  border-radius: 10px;
  padding: 7px;
  background-color: #585e66;
  color: #c6c7c8;
  margin-left: 5px;
  cursor: pointer;
  margin-left: 5px;
`;

export const ExtraReports = styled.div`
  width: 100%;
  height: calc(100% - 4.5rem);
  bottom: 0;
  position: absolute;
  background-color: #585e66;
  border-radius: 8px;
  padding: 0 10px;
  box-sizing: border-box;
  border: #212326 5px solid;

  animation: slideIn 0.25s forwards;

  @keyframes slideIn {
    from {
      left: 0;
      opacity: 0;
    }
    to {
      left: 101%;
      opacity: 1;
    }
  }
  z-index: 20;
`;
